export default __webpack_public_path__ + "images/Mexican.f2a42f.jpg";